import type { ReactNode } from 'react';

export type BadgeTone = 'live' | 'scheduled' | 'review' | 'draft' | 'done' | 'alert' | 'neutral';

const TONES: Record<BadgeTone, string> = {
  live: 'bg-primary-500 text-background-50 border border-primary-500',
  scheduled: 'bg-secondary-100 text-secondary-900 border border-secondary-200',
  review: 'bg-accent-100 text-accent-900 border border-accent-300',
  draft: 'bg-background-200 text-foreground-700 border border-background-300',
  done: 'bg-primary-100 text-primary-700 border border-primary-200',
  alert: 'bg-foreground-950 text-accent-400 border border-foreground-950',
  neutral: 'bg-background-100 text-foreground-600 border border-background-200',
};

/** Consistent status pill used across every management surface. */
export default function StatusBadge({ tone, children, className = '' }: { tone: BadgeTone; children: ReactNode; className?: string }) {
  return (
    <span className={`inline-flex items-center font-label font-bold uppercase tracking-wide text-[10px] px-2.5 py-1 rounded-sm whitespace-nowrap ${TONES[tone]} ${className}`}>
      {children}
    </span>
  );
}